
import { filtersDTO, NotProcessingResponseDTO } from "./dto";
import { NotProcessingImpl } from "./serviceImpl";

export interface NotProcessingService {
    GetAllNotProcessing(filters: filtersDTO): Promise<NotProcessingResponseDTO>
    IdentificationBoardProcessingNotification(notId: string): Promise<void>
}

export function NewNotProcessingService(): NotProcessingService {
    return new NotProcessingImpl()
}